<nav>
  <ul class="flex items-center gap-32">
    <ng-container *ngFor="let link of links">
      <li>
        <a
          *ngIf="link.external"
          href="{{ link.url }}"
          target="_blank"
        >
          <span>{{ link.text }}</span>
        </a>
        <a
          *ngIf="!link.external"
          [routerLink]="link.url"
          href="#"
          class=""
          routerLinkActive="text-red is-active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span>{{ link.text }}</span>
        </a>
      </li>
    </ng-container>
    <li>
      <app-register-button></app-register-button>
    </li>
  </ul>
</nav>
